export default __webpack_public_path__ + "static/messaging-platform-cta-2-_x_-963ef80da91f65f9835f0f5a9aaa69a5.jpg";